module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading-screen'), _vm._v(" "), _c('nav-bar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('current-action'), _vm._v(" "), _c('errors'), _vm._v(" "), (_vm.footerVisible) ? _c('div', {
    staticClass: "contact"
  }, [_vm._v("\n    Crafted with ❤️ by "), _c('a', {
    attrs: {
      "href": "mailto:damian@swistowski.org"
    }
  }, [_vm._v("DŚ")]), _vm._v(", "), _vm._m(0), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": "https://itemmanager.uk/",
      "title": "Item Manager for Destiny 2",
      "description": "Item manager allows you transfer your items between characters with one click",
      "quote": "The fastest item manager for Destiny 2.",
      "hashtags": "destiny,item,manager,vault",
      "twitter-user": "itemmanager"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "shares"
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "googleplus"
            }
          }, [_c('i', {
            staticClass: "fa fa-google-plus"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-envelope"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "reddit"
            }
          }, [_c('i', {
            staticClass: "fa fa-reddit"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-whatsapp"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons close",
    on: {
      "click": function($event) {
        _vm.footerVisible = false
      }
    }
  }, [_vm._v("close")])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/dswistowski/itemmanager-issues/issues"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e763e3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 551
// module chunks = 1